import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-2v3',
  templateUrl: './2v3.component.html',
})
export class VbGeneral2v3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
